<template>
  <div style="max-width: 850px; margin: 0px auto">
     <div v-if="info.show_search" class="drop-down coach-search" 
        @focus="showResults=true"
        @focusout="showResults=false"
        tabindex="0"
    >
       <div>Share your results with an Incredible Coach</div>
       <h-input v-model='search' placeholder='Search' />
       <div class="items" >
         <div v-if='showResults'>
          <div class="item" v-if="searchLoading">
           <div class="coach-name">
             Loading...
           </div>
          </div>
          <div class="item" v-if="nonFound && !searchLoading">
           <div class="coach-name">
             No coach found 
           </div>
          </div>
          <div class="item" @click="sendResults(coach)" v-for="coach in searchableCoaches" :key="coach.id">
            <avatar :image="coach.image" size="30" /> 
            <div class="coach-name">{{coach.firstName}} {{coach.lastName}}</div>
          </div>
         </div>
       </div>
    </div>

    <assessment-results :results="results" :referConsultation="referConsultation"> 
      <cta :cta="info" v-if="info.cta_link && info.cta_enabled && !AuthUser.id"  style="margin-top: 20px" />
    </assessment-results>
    <modal btn="close" title="Success" v-if="showSuccess" @submit="showSuccess=false" @close="showSuccess=false">
      <div>We've sent them an email with your results</div>
    </modal>
  </div>
</template>

<script>
import axios from "axios";
import assessmentResults from "@/components/assessmentResults";
import cta from "@/components/assessmentResults/cta";
import avatar from "@/components/userImg";
import AuthUser from "@/services/api/authUser";
import gql from "graphql-tag";
import snackbarHub from "@/services/hubs/snackbar";
import modal from "@/components/modal/default";


const SEARCHABLE_COACHES = gql`
  query searchableCoaches($search: String!){
    searchableCoaches(search: $search) {
      firstName,
      lastName,
      image,
      email
    }
  }
`;

const GRANT_ACCESS = gql`
  mutation grantAccess($input: GrantAssessmentAccessInput!) {
    grantAssessmentAccessMutation(input: $input) {
      grantedAccess {
        id
      }
    }
  }
`

export default {
  components: { assessmentResults, avatar, cta, modal },
  apollo: {
    searchableCoaches: {
      query: SEARCHABLE_COACHES,
      variables() {
        return {
          search: this.realSearch
        };
      },
      skip() {
        return !this.realSearch
      },
    }
  },
  data() {
    return {
      results: [],
      referConsultation: false,
      info: {},
      AuthUser,
      search: '',
      searchableCoaches: [],
      realSearch: '',
      bouncing: false,
      showResults: false,
      showSuccess: false
    };
  },
  watch: {
    search(newVal) {
      this.showResults = true;
      this.bouncing = true;
      clearTimeout(this.searchTimeout);
      this.searchableCoaches = [];
      this.searchTimeout = setTimeout(() => {
        this.bouncing = false;
        this.realSearch = newVal;
      }, 1000);
    }
  },
  created() {
    let id = this.$route.params.id;
    axios
      .get(`${process.env.VUE_APP_API_URL}lead-assessments/${id}/break_down/`)
      .then(({ data }) => {
        this.results = data;
      });
    axios
      .get(`${process.env.VUE_APP_API_URL}lead-assessments/${id}/`)
      .then(({data})=> {
        let assessmentId = process.env.VUE_APP_FREE_ASSESSMENT_ID
        this.referConsultation = data.assessment == assessmentId;
        this.info = data;
      });
  },
  methods: {
    find() {
      this.loading = true;
    },
    sendResults(coach) {
      this.showResults = false;
      this.$apollo.mutate({
        mutation: GRANT_ACCESS,
        variables: {
          input: {
            email: coach.email,
            leadAssessment: this.$route.params.id
          }
        }
      });
      this.showSuccess = true;
      snackbarHub.update("Success");
    }
  },
  computed: {
    display() {
      return this.results.find(x => x.uuid === this.selected);
    },
    nonFound() {
      return this.searchableCoaches.length == 0 && this.search && !this.$apollo.queries.searchableCoaches.loading
    },
    searchLoading() {
      let b = this.bouncing || this.$apollo.queries.searchableCoaches.loading;
      return b
    }
  }
};
</script>


<style lang="less">
  .drop-down {
    position: relative;
    width: 100%;

    .items {
      width: 100%;
      background-color: white;
      position: absolute;
      z-index: 1;
      border-radius: 5px;
      margin-top: 3px;
      max-height: 350px;
      overflow: hidden;
      overflow-y: auto;
      .item {
        display: flex;
        flex-direction: row;
        padding: 5px 10px;
        align-content: center; 
        cursor: pointer;

        .coach-name {
          align-items: center;
          justify-content: center;
          display: flex;
          font-size: 15px;
          padding-left: 8px;
        }
      }
    }
  }

  .coach-search {
    width: 100%;
    margin-bottom: 15px;
    @media (min-width: 700px) {
      width: 50%;
    }
  }

</style>
